import style from "./style.module.scss";
import Logo from "../../logo";
import { Breadcrumb } from "../../../../ui";
import { LoginButton, Username } from "../../../../security";

interface BreadcrumbItem {
  label: string;
  link?: string;
}

interface HeaderProps {
  breadcrumbItems?: BreadcrumbItem[];
}

function Header({ breadcrumbItems }: HeaderProps) {
  return (
    <div className={style.container}>
      <div className={style.left}>
        <Logo small title="Retour à l'accueil" />
        {breadcrumbItems && <Breadcrumb items={breadcrumbItems} className={style.breadcrumb} />}
      </div>
      <div className={style.right}>
        <Username />
        <LoginButton />
      </div>
    </div>
  );
}

export default Header;
